import {Segment} from 'semantic-ui-react';

function ErrorMessage(props) {
  return (
    <Segment>
      <div className='text-center text-large text-medium'>
        <p>{`کاربر گرامی، ${props.message}`}</p>
        <p>
          برای حل مشکل لطفا با مشاور خود یا
          <a href='https://t.me/medmoshaver_admin'> اکانت ادمین کانال تلگرام </a>
          به آدرس
          <a href='https://t.me/medmoshaver_admin'> www.t.me/medmoshaver_admin </a>
          در ارتباط باشید.
        </p>
      </div>
    </Segment>
  );
}

export default ErrorMessage;
